import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-arrow-forward-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_26414_15915)">
        <path
          d="M8.0013 2.66797L7.0613 3.60797L10.7813 7.33464H2.66797V8.66797H10.7813L7.0613 12.3946L8.0013 13.3346L13.3346 8.0013L8.0013 2.66797Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_26414_15915">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrowForwardIconComponent {
  @Input() width = 16;
  @Input() height = 16;
}
